// The eYantra storefront is the retail Brandstore's design (brandstore-frontend/src/retail)
// run against eYantra's own catalogue. Where retail reads per-tenant settings, this store has
// fixed ones — kept here so the components stay close to their retail originals (the two
// storefronts may be merged later; see docs/retail-storefront.md).

// localStorage prefix for the bag, wishlist and recently viewed (retail uses the tenant slug).
export const SLUG = 'eyantra';

// Prepaid checkout (phase 2). Until it ships, the bag ends in a quote request and there's no
// "Buy now" button.
export const CHECKOUT_ENABLED = false;

// The store speaks to individual shoppers by default. Bulk orders and logo branding — what
// companies buy — live on their own page (CORPORATE, /corporate), linked from the header.
export const STORE = {
  displayName: 'eYantra',
  tagline: 'Authentic brands, delivered across India',
  // Shown under the hero heading when there are no banner images.
  heroText: 'Electronics, Apparel, Luggage and Travel, Home and more from the brands you trust, with delivery across India.',
};

export const CORPORATE = {
  path: '/corporate',
  navLabel: 'For business',
  linkLabel: 'Corporate orders',
  // Quotes and bulk enquiries (the address customers already use for quotes).
  email: 'quotes@eyantra.com',
};
